import React from "react";
import { useNavigate } from "react-router-dom";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import Spinner from "Common/Globle/Spinner";
import CommunicationSettingsForm from "./Components/CommunicationSettingsForm";
import fields from "./json/CommunicationSettingsFields.json";

// Import your custom global API wrappers
import {
  GetCommunicationSettings,
  UpdateCommunicationSettings
} from "adminApi/CommunicationSettingsApi/CommunicationSettings";

const CommunicationSettings = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // 1. Initial State
  const initialValues = formdata.reduce(
    (acc, field) => ({ ...acc, [field.name]: "1" }),
    {}
  );

  const { values, handleChange, setValues } = useFormChange(
    initialValues,
    {} // No complex validation rules needed for switches
  );

  // 2. Fetch global system settings (passes placeholder ID to execute custom hook)
  const { loading: loadingFetch } = useFetchFormDataById(
    "global",
    formdata,
    GetCommunicationSettings,
    setValues
  );

  // 3. Save Settings Handler - matches your Update({ id, data }) pattern
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      return await UpdateCommunicationSettings({ data: formValues });
    },
    () => {
      return {}; // No validation checks needed for toggling simple switches
    },
    () => {
      // Success callback
      // navigate(-1);
    },
    "Communication settings updated successfully!"
  );

  return (
    <>
      {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
      <CommunicationSettingsForm
        fields={formdata}
        values={values}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
      />
    </>
  );
};

export default CommunicationSettings;
